import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { getStorages } from "../../../slices/inventory/storage"
import DashboardHeader from "../../../components/dashboard/dashboardHeader"
import InventoryStorageStacklist from "../../../components/dashboard/inventory/inventory-storage-stacklist"
import InventoryStorageModal from "../../../components/dashboard/inventory/InventoryStorageModal"
import { PickingListReminderSettings } from "../../../components/dashboard/inventory/PickingListReminderSettings"
import { Cog6ToothIcon } from "@heroicons/react/24/outline"

export const InventorySettings = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  
  const itemState = useSelector((store) => {
    return store.inventory_storages
  })

  const { isLoading, error, errors, data } = itemState
  const [newStorageModalOpen, setNewStorageModalOpen] = useState(false)

  useEffect(() => {
    dispatch(getStorages())
  }, [dispatch])

  return (
    <>
      <DashboardHeader
        title={t("inventory.settings.title")}
        subtitle={t("inventory.settings.subtitle")}
        mainButton={{
          label: t("inventory.settings.new_storage"),
          icon: Cog6ToothIcon,
          action: () => setNewStorageModalOpen(true),
        }}
      />
      <div className="mx-auto max-w-7xl px-3 sm:px-6 lg:px-8">
        <div className="mt-8 space-y-8">
          <PickingListReminderSettings />
          <div className="rounded-lg bg-white shadow-sm ring-1 ring-inset ring-gray-200">
            <InventoryStorageStacklist
              label={t("inventory.settings.storages")}
              isLoading={isLoading}
              error={error}
              errors={errors}
              items={data}
            />
          </div>
        </div>
      </div>

      <InventoryStorageModal
        onClose={() => setNewStorageModalOpen(false)}
        open={newStorageModalOpen}
        itemId={0}
      />
    </>
  )
}